import { render, staticRenderFns } from "./route.vue?vue&type=template&id=8f7a9932"
import script from "./route.vue?vue&type=script&lang=js"
export * from "./route.vue?vue&type=script&lang=js"
import style0 from "./route.vue?vue&type=style&index=0&id=8f7a9932&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports